//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.ProfileQuery
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object ProfileQuery_ResponseAdapter {
  public object Data : Adapter<ProfileQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("profile")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ProfileQuery.Data {
      var _profile: ProfileQuery.Profile? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _profile = Profile.obj().nullable().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ProfileQuery.Data(
        profile = _profile
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ProfileQuery.Data,
    ) {
      writer.name("profile")
      Profile.obj().nullable().toJson(writer, customScalarAdapters, value.profile)
    }
  }

  public object Profile : Adapter<ProfileQuery.Profile> {
    public val RESPONSE_NAMES: List<String> = listOf("id", "fullName", "emailAddress", "accesses")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ProfileQuery.Profile {
      var _id: Any? = null
      var _fullName: String? = null
      var _emailAddress: String? = null
      var _accesses: ProfileQuery.Accesses? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _fullName = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _emailAddress = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _accesses = Accesses.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ProfileQuery.Profile(
        id = _id ?: missingField(reader, "id"),
        fullName = _fullName ?: missingField(reader, "fullName"),
        emailAddress = _emailAddress ?: missingField(reader, "emailAddress"),
        accesses = _accesses ?: missingField(reader, "accesses")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ProfileQuery.Profile,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("fullName")
      StringAdapter.toJson(writer, customScalarAdapters, value.fullName)

      writer.name("emailAddress")
      StringAdapter.toJson(writer, customScalarAdapters, value.emailAddress)

      writer.name("accesses")
      Accesses.obj().toJson(writer, customScalarAdapters, value.accesses)
    }
  }

  public object Accesses : Adapter<ProfileQuery.Accesses> {
    public val RESPONSE_NAMES: List<String> = listOf("readOnly", "readWrite")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ProfileQuery.Accesses {
      var _readOnly: List<String>? = null
      var _readWrite: List<String>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _readOnly = StringAdapter.list().fromJson(reader, customScalarAdapters)
          1 -> _readWrite = StringAdapter.list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ProfileQuery.Accesses(
        readOnly = _readOnly ?: missingField(reader, "readOnly"),
        readWrite = _readWrite ?: missingField(reader, "readWrite")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ProfileQuery.Accesses,
    ) {
      writer.name("readOnly")
      StringAdapter.list().toJson(writer, customScalarAdapters, value.readOnly)

      writer.name("readWrite")
      StringAdapter.list().toJson(writer, customScalarAdapters, value.readWrite)
    }
  }
}
